import {
  get,
  useFormContext,
} from "react-hook-form";
import classNames from "classnames";
import {
  forwardRef,
  ReactElement, TextareaHTMLAttributes,
  useEffect,
  useState
} from "react";

export type TextAreaInputProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "name"> & {
  className?: string;
  innerClassName?: string;
  name: string;
  label: string;
  children?: ReactElement;
}

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaInputProps>(({
  className,
  innerClassName,
  label,
  children,
  name,
  ...rest
}: TextAreaInputProps, ref) => {
  const {formState} = useFormContext();
  const [error, setError] = useState<string>();

  useEffect(() => {
    const fieldError = get(formState.errors, name);
    if (fieldError) {
      setError(fieldError.message);
    } else {
      setError(undefined);
    }
  }, [formState, name]);

  const padding = children ? "pl-2 pr-8" : "px-2";

  const style = error
    ? `border-red-500 ${padding}`
    : `border-gray-400 ${padding}`;

  return (
    <div className={className}>
      <label className="text-sm" htmlFor={name}>{label}</label>
      <div className="relative w-full select-none">
        <textarea id={name} name={name} ref={ref} {...rest}
          className={classNames(style, innerClassName,
            "peer appearance-none block w-full border rounded py-0.5"
          )}/>
        {children}
      </div>
      <div className={classNames("text-xs text-red-500",
        error ? "" : "invisible"
      )}>
        {error ?? "Valid"}
      </div>
    </div>
  );
});

TextArea.displayName = "TextArea";
